export const NUMERO_TWILIO_FAST = 'whatsapp:+5218123255321'
export const ESCUELA_FAST = 2
export const MEDIA_BASE = 'https://escuelakpi.club/imagenes-whatsapp/'

export const ADMIN_ERP_IDS = [1, 334, 568, 32, 31, 28]
export const ADMIN_FILTRO_FINALIZO_IDS = [1, 28, 31, 32, 334, 568, 3176]
export const ADMIN_FILTRO_AGENTE_IA_IDS = [1, 28, 31, 32, 334, 568]

/** Misma lista que rh-front `twilioUsuariosAdmin.js` + 28 */
export const TWILIO_USUARIOS_ADMIN = [
  334, 3015, 1, 568, 32, 31, 718, 1183, 1258, 2155, 2268, 2269, 2342, 954, 2472,
  2556, 2574, 2230, 2767, 2817, 1312, 2910, 2354, 2493, 1794, 1152, 161, 3042, 28,
]

/** Botón header “Filtrar por vendedora” — TwilioFast.vue */
export const FILTRO_VENDEDORAS_IDS = [
  334, 3015, 1, 568, 32, 31, 718, 1183, 1258, 2155, 2268, 2269, 2342, 954, 2472,
  1312, 2230, 2767, 2910, 28,
]

/** Extra de `accesosBoton` (select Incompletos) */
export const ACCESOS_BOTON_EXTRA_IDS = [568, 334, 1, 32, 31, 1312, 2230, 954, 2767, 2910, 28]

export const CHATS_POR_PAGINA = 50

/** Misma lista que el botón Reasignar de TwilioFast.vue */
export const REASIGNAR_CHAT_IDERP_IDS = [
  1, 3, 568, 334, 3015, 2268, 2155, 2472, 1312, 2230, 954, 2767, 2910,
]

export function esAdminErp (id) {
  return ADMIN_ERP_IDS.includes(Number(id))
}

export function puedeReasignarChat (iderp, chat) {
  if (!REASIGNAR_CHAT_IDERP_IDS.includes(Number(iderp))) return false
  return !!(chat && chat.folio && chat.idprospectos)
}

/** Reasignación masiva en lista (mismo criterio que vista Admin de esta app). */
export function puedeReasignarMasivo (iderp) {
  return esAdminErp(iderp)
}

export function esUsuarioTwilioAdmin (iderp) {
  const id = Number(iderp)
  return Number.isFinite(id) && TWILIO_USUARIOS_ADMIN.includes(id)
}

export function puedeFiltrarPorVendedora (iderp) {
  const id = Number(iderp)
  return Number.isFinite(id) && FILTRO_VENDEDORAS_IDS.includes(id)
}

export function accesosBotonIncompletos (iderp) {
  const id = Number(iderp)
  if (!Number.isFinite(id)) return false
  return esUsuarioTwilioAdmin(id) || ACCESOS_BOTON_EXTRA_IDS.includes(id)
}

export function chatTieneFolioUsable (chat) {
  const f = chat && chat.folio
  if (f == null || f === 0 || f === '0') return false
  return String(f).trim().length > 0
}

export function chatTieneIdProspecto (chat) {
  const id = Number(chat && chat.idprospectos)
  return Number.isFinite(id) && id > 0
}

export function chatTieneFolioOProspecto (chat) {
  return chatTieneFolioUsable(chat) || chatTieneIdProspecto(chat)
}

export function mensajeEsFichaTecnica (msg) {
  const t = String(msg || '')
  if (!t || t.length < 40) return false
  if (/as[ií]\s+qued[oó]\s+tu\s+pre\s*registro/i.test(t)) return true
  const tieneFolioBeca = /folio\s+de\s+beca/i.test(t)
  const tieneFelicidades = /felicidades/i.test(t)
  const tieneNombre = /\*?\s*Nombre\s*:?\s*\*?/i.test(t)
  const tieneEdad = /\*?\s*Edad\s*:?\s*\*?/i.test(t)
  const tieneModalidadOPlantel = /\*?\s*Modalidad\s*:?\s*\*?/i.test(t)
    || /\*?\s*Plantel\s*:?\s*\*?/i.test(t)
  const tieneHorario = /\*?\s*Horario\s*:?\s*\*?/i.test(t)
  if (tieneFolioBeca && tieneFelicidades && tieneNombre) return true
  if (tieneNombre && tieneEdad && tieneModalidadOPlantel && (tieneHorario || tieneFolioBeca)) return true
  if (/confirmando\s+tus\s+datos/i.test(t) && tieneNombre && tieneEdad) return true
  return false
}

export function chatTieneFichaTecnica (chat) {
  if (!chat || typeof chat !== 'object') return false
  if (chat.ficha_tecnica_enviada === true || chat.ficha_tecnica_enviada === 1) return true
  if (chat.ficha_tecnica_enviada === false || chat.ficha_tecnica_enviada === 0) return false
  return mensajeEsFichaTecnica(chat.mensaje || chat.Body || chat.body)
}

export function chatViaAgenteIA (chat) {
  if (!chat) return false
  if (Number(chat.via_ia) === 1) return true
  if (Number(chat.via_susana) === 1) return true
  if (Number(chat.usuario_asignado) === 3176) return true
  if (chat.id_vendedora_posible != null && Number(chat.id_vendedora_posible) > 0) return true
  return String(chat.utm_source || '').toUpperCase() === 'SUSANA_IA'
}

export const LIMITE_IMAGEN_BYTES = 5 * 1024 * 1024
export const LIMITE_AUDIO_VIDEO_BYTES = 16 * 1024 * 1024
export const LIMITE_DOCUMENTO_BYTES = 100 * 1024 * 1024

export function validarTamanoMedia (file) {
  if (!file) return null
  const name = String(file.name || '').toLowerCase()
  const type = String(file.type || '').toLowerCase()
  const size = Number(file.size) || 0
  const isImg = type.startsWith('image/') || /\.(jpe?g|png|webp|gif|svg)$/.test(name)
  const isAudio = type.startsWith('audio/') || /\.(mp3|m4a|aac|ogg|wav|mpeg)$/.test(name)
  const isVideo = type.startsWith('video/') || /\.(mp4|mov|avi)$/.test(name)
  const max = isImg
    ? LIMITE_IMAGEN_BYTES
    : (isAudio || isVideo)
      ? LIMITE_AUDIO_VIDEO_BYTES
      : LIMITE_DOCUMENTO_BYTES
  if (size > max) {
    const mb = Math.round(max / (1024 * 1024))
    return `El archivo supera el límite de ${mb} MB de WhatsApp.`
  }
  return null
}

export function formatearNombre (nombreCompleto) {
  if (!nombreCompleto || typeof nombreCompleto !== 'string') return ''
  return nombreCompleto
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1))
    .join(' ')
}

export function telefonoVisible (usuario) {
  return String(usuario || '').replace(/^whatsapp:/i, '').replace(/^\+52/, '')
}

export function nombreProspecto (chat) {
  const raw = String((chat && (chat.nombre_completo || chat.nombre_alumno)) || '').trim()
  if (!raw) return ''
  const upper = raw.toUpperCase()
  if (
    upper.includes('INCOMPLETO')
    || upper.includes('CONTACTO')
    || upper === 'TWILIO'
    || upper.includes('SIN NOMBRE')
  ) return ''
  return formatearNombre(raw) || raw
}

export function chatEnControlManual (chat) {
  if (!chat || typeof chat !== 'object') return false
  if (chat.humano_tomo_control === true || chat.humano_tomo_control === 1) return true
  if (String(chat.control_conversacion || '').toLowerCase() === 'humano') return true
  if (chat.ia_puede_responder === false || chat.ia_puede_responder === 0) return true
  return false
}

export function chatRequiereAtencion (chat) {
  if (!chat || typeof chat !== 'object') return false
  if (chat.requiere_atencion === true || chat.requiere_atencion === 1) return true
  if (String(chat.etiqueta_atencion || '').toUpperCase() === 'ATENCION') return true
  if (/^atencion:/i.test(String(chat.motivo_pausa_ia || ''))) return true
  return false
}

export function horaLista (raw) {
  if (!raw) return ''
  const s = String(raw).trim()
  const partes = s.includes('T') ? s.replace('T', ' ').split(' ') : s.split(' ')
  const fecha = partes[0] || ''
  const hora = (partes[1] || '').slice(0, 5)
  const hoy = new Date()
  const yyyy = hoy.getFullYear()
  const mm = String(hoy.getMonth() + 1).padStart(2, '0')
  const dd = String(hoy.getDate()).padStart(2, '0')
  const hoyIso = `${yyyy}-${mm}-${dd}`
  if (!partes[1]) return fecha.slice(0, 5)
  if (fecha === hoyIso) return hora
  const m = fecha.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) return `${m[3]}/${m[2]}/${m[1]}`
  return hora || s
}

export function horaBurbuja (raw) {
  if (!raw) return ''
  const s = String(raw).trim().replace('T', ' ')
  const partes = s.split(' ')
  if (partes[1]) return partes[1].slice(0, 5)
  return s.slice(0, 5)
}

export function etiquetaFechaChat (raw) {
  if (!raw) return ''
  const s = String(raw).trim()
  const fecha = s.replace('T', ' ').split(' ')[0] || ''
  const m = fecha.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!m) return fecha
  const hoy = new Date()
  const yyyy = hoy.getFullYear()
  const mm = String(hoy.getMonth() + 1).padStart(2, '0')
  const dd = String(hoy.getDate()).padStart(2, '0')
  if (`${m[1]}-${m[2]}-${m[3]}` === `${yyyy}-${mm}-${dd}`) return 'Hoy'
  return `${m[3]}/${m[2]}/${m[1]}`
}

export function urlMedia (nombre) {
  if (!nombre) return ''
  const raw = String(nombre)
  if (/^(https?:|data:|blob:)/i.test(raw)) return raw
  return MEDIA_BASE.replace(/\/?$/, '/') + raw.replace(/^\//, '')
}

export function parseChatsResponse (data) {
  if (Array.isArray(data)) {
    return { chats: data, pagination: { hasMore: false } }
  }
  const chats = data && Array.isArray(data.chats) ? data.chats : []
  return {
    chats,
    pagination: (data && data.pagination) || { hasMore: false, returned: chats.length },
  }
}
